// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.back-button {
  margin: 10px;
  width: 25px;
  height: 25px;
}

.upload-btn-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;
}
.upload-btn-wrapper label {
  display: flex;
}
.upload-btn-wrapper .icon-not-send {
  font-size: 26px;
  cursor: pointer;
}

.btn-publish {
  margin: auto auto 10px auto;
  width: 95%;
  padding: 10px;
  height: 45px;
  font-family: var(--font);
  font-weight: 700;
  font-size: 1em;
  text-transform: none;
  display: flex;
  border-radius: 3px;
}
.btn-publish > ion-icon {
  margin: auto 1px auto auto;
}
.btn-publish > span {
  margin: auto;
}

.background {
  padding-top: 5px;
}

#textArea {
  height: 20vh;
}

.post-user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.06);
}

.user-comment-picture {
  height: 38px;
  width: 38px;
  border-radius: 50%;
}

.user-name {
  font-weight: 600;
}

.date {
  font-size: 0.8em;
  font-weight: 300;
}

.post-description {
  margin: 6px 16px 15px;
  font-family: var(--font);
}

.img-post {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
}

.post-n-comment-div {
  margin-left: 17px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.delete-btn {
  float: right;
  padding-right: 10px;
}

.align-texts-like {
  width: 100%;
  display: inline-flex;
  align-items: center;
}

.icon-like {
  font-size: 1.4em;
}

.icon-comment {
  margin-right: 3px;
  font-size: 1.4em;
}

@media only screen and (min-width: 320px) {
  .normal-text {
    font-size: 0.96em;
  }
}
.total-likes {
  margin-left: 8px;
}

.input-comment {
  resize: none;
}

.pos-btn-send {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-col-size {
  display: flex;
  align-items: center;
}

.btn-send-msg {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-send {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-more {
  text-align: center;
}

.icon-fixed {
  float: right;
}

#icon_fixed {
  width: 17px;
  height: 17px;
}

.icon-trash {
  float: right;
}

.color-trash {
  color: #c91f1f;
}

.st0 {
  fill: #808080;
}

.btn-attach-picture {
  font-size: 22px;
}

.display-flex-align {
  display: flex;
  align-items: center;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.separator-vertical {
  width: 1px;
  background: var(--text-color-2nd-login-desktop);
  margin-right: 6px;
  opacity: 0.09;
}

#myImg {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
}

.description-input {
  padding-top: 10px;
  height: 85vh;
  resize: none;
  background: #ffffff;
  border-bottom: 1px solid #ECEAF3;
  --placehoder-color: #9D93C2;
  font-style: var(--font);
  font-weight: 400;
}

.text-input-ios {
  margin: 0 auto;
}

.text-input-md {
  margin: 0 auto;
}

.mg-card {
  height: 90.5vh;
}

.btn-default {
  padding: 8px;
  font-size: 1em;
  border-radius: 15px;
  min-width: 100%;
}

ion-avatar {
  width: 46px;
  height: 46px;
  border: 2px solid transparent;
  padding: 1px;
  cursor: pointer;
}
ion-avatar img {
  width: 44px;
}

.profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  background: var(--bg-color);
  padding: 10px;
}
.profile-picture .cus-picture {
  width: 16px;
  height: 16px;
  margin: auto;
  border-radius: 0;
  opacity: 0.6;
}

.name-post {
  font-family: var(--font);
  font-weight: 600;
  cursor: pointer;
}

.post-date {
  font-family: var(--font);
  font-weight: 300;
  opacity: 0.5;
}

.post-card-content {
  padding: 0;
}
.post-card-content .post-img {
  max-height: 60%;
  display: block;
}

.align-footer-post ion-col {
  display: flex;
}
.align-footer-post ion-col .like-container {
  display: flex;
  padding-left: 9px;
}
.align-footer-post ion-col .align-texts-comment {
  display: inline-flex;
  margin-left: 8px;
}
.align-footer-post ion-col .nbr-likes-cmts {
  font-family: var(--font);
  font-weight: 300;
  font-size: 14px;
  margin: auto 0 auto 5px;
}
.align-footer-post ion-col ion-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.social-sharing {
  float: right;
  font-size: 1.2em;
}

.header-post-item {
  border: none !important;
  padding: 0 !important;
}

.align-button-options {
  display: flex;
  justify-content: flex-end;
}

.more-options-btn {
  font-size: 1.4em;
}

.bottom-form {
  margin: auto;
  width: 98vw;
  height: 60vh;
  border: 3px solid rgb(212, 210, 210);
  background-color: rgb(232, 232, 232);
  padding: 10px;
}
.bottom-form .btn-icon {
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  margin-right: auto;
  width: 35%;
  height: auto;
}
.bottom-form > a {
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  height: 50%;
}

.bottom-form2 {
  margin: auto;
  width: 55%;
  height: auto;
  max-height: 40%;
  border: 3px solid rgb(212, 210, 210);
  background-color: rgb(232, 232, 232);
  padding: 10px;
}
.bottom-form2 ion-icon {
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  height: auto;
  max-height: 40%;
}
.bottom-form2 > a {
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  height: 50%;
  max-height: 40%;
}

ion-spinner {
  margin: auto;
  width: 5vw;
  height: 2vh;
  padding: 10px;
}

ion-card {
  max-width: 600px;
  margin: 15px auto !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 2px 9px 0 rgba(0, 0, 0, 0.1);
}

.btn-more {
  --background: transparent;
  color: black;
  --box-shadow: none;
  --background-hover: rgb(0 0 0 / 0.03);
  --background-focused: rgb(0 0 0 / 0.03);
}
.btn-more ion-icon {
  transform: rotate(90deg);
  width: 1.3rem;
  height: 1.3rem;
}

.container {
  position: relative;
}
.container > .wait-content {
  position: absolute;
  top: 15px;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.3rem;
}
.container ion-icon {
  height: 300px;
  width: 100%;
}
.container .text-empty-content {
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: auto;
  text-align: center;
  font-family: var(--font);
}
.container .text-empty-content .title {
  font-weight: 600;
  font-size: 17px;
  margin-bottom: 10px;
}

@media screen and (min-width: 768px) {
  .container ion-icon {
    height: 440px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/feed-news/feed-news-publishing/feed-news-publishing.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AACA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AAEJ;;AACA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAEJ;AAAI;EACI,aAAA;AAER;AACI;EACI,eAAA;EACA,eAAA;AACR;;AAGA;EACI,2BAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,cAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;AACJ;AACI;EACI,0BAAA;AACR;AAEI;EACI,YAAA;AAAR;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;AADJ;;AAIA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,qBAAA;EAEA,wBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AAFJ;;AAaA;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,YAAA;EACA,mBAAA;AAVJ;;AAaA;EACI,WAAA;EACA,oBAAA;EACA,mBAAA;AAVJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,iBAAA;EACA,gBAAA;AAXJ;;AAeA;EACI;IACI,iBAAA;EAZN;AACF;AAeA;EACI,gBAAA;AAbJ;;AAgBA;EACI,YAAA;AAbJ;;AAgBA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,mBAAA;AAbJ;;AAgBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbJ;;AAgBA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;;AAgBA;EACI,kBAAA;AAbJ;;AAgBA;EACI,YAAA;AAbJ;;AAgBA;EACI,WAAA;EACA,YAAA;AAbJ;;AAgBA;EACI,YAAA;AAbJ;;AAgBA;EACI,cAAA;AAbJ;;AAgBA;EACI,aAAA;AAbJ;;AAgBA;EACI,eAAA;AAbJ;;AAgBA;EACI,aAAA;EACA,mBAAA;AAbJ;;AAgBA;EACI,YAAA;AAbJ;;AAgBA;EACI,WAAA;AAbJ;;AAgBA;EACI,UAAA;EAEA,+CAAA;EACA,iBAAA;EACA,aAAA;AAdJ;;AAiBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAdJ;;AAiBA;EACI,iBAAA;EAEA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,uBAAA;EAAyB,gBAAA;AAd7B;;AAiBA;EACI,cAAA;AAdJ;;AAiBA;EACI,cAAA;AAdJ;;AAiBA;EACI,cAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAdJ;AAgBI;EACI,WAAA;AAdR;;AAkBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,aAAA;AAfJ;AAiBI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAfR;;AAmBA;EAGI,wBAAA;EAA0B,gBAAA;EAE1B,eAAA;AAlBJ;;AAqBA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,YAAA;AAjBJ;;AAoBA;EACI,UAAA;AAjBJ;AAmBI;EAEI,eAAA;EAGA,cAAA;AApBR;;AA8BI;EACI,aAAA;AA3BR;AA6BQ;EACI,aAAA;EAEA,iBAAA;AA5BZ;AA+BQ;EAEI,oBAAA;EACA,gBAAA;AA9BZ;AAmCQ;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,uBAAA;AAhCZ;AAmCQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAjCZ;;AAsCA;EACI,YAAA;EACA,gBAAA;AAnCJ;;AAsCA;EACI,uBAAA;EACA,qBAAA;AAnCJ;;AAsCA;EACI,aAAA;EACA,yBAAA;AAnCJ;;AAsCA;EACI,gBAAA;AAnCJ;;AAsCA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;AAnCJ;AAqCI;EACI,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAnCR;AAsCI;EACI,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AApCR;;AAwCA;EACI,YAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;AArCJ;AAuCI;EACI,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AArCR;AAwCI;EACI,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;AAtCR;;AA0CA;EACI,YAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AAvCJ;;AA0CA;EACI,gBAAA;EACA,4BAAA;EAEA,0EAAA;AAxCJ;;AA2CA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,uCAAA;AAxCJ;AA0CI;EACI,wBAAA;EACA,aAAA;EACA,cAAA;AAxCR;;AA2CA;EACI,kBAAA;AAxCJ;AAyCI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,iBAAA;AAtCR;AAwCI;EACI,aAAA;EACA,WAAA;AAtCR;AAwCI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;AAtCR;AAuCQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AArCZ;;AAyCA;EAEQ;IACI,aAAA;EAvCV;AACF","sourcesContent":[".input-file {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n}\n.back-button{\n    margin: 10px;\n    width: 25px;\n    height: 25px;\n\n}\n.upload-btn-wrapper {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0px 10px;\n\n    label {\n        display: flex;\n    }\n\n    .icon-not-send {\n        font-size: 26px;\n        cursor: pointer;\n    }\n}\n\n.btn-publish {\n    margin: auto auto 10px auto;  \n    width: 95% ;\n    padding: 10px;\n    height: 45px;\n    font-family: var(--font); font-weight: 700;;\n    font-size: 1em;\n    text-transform: none;\n    display: flex;\n    border-radius: 3px;\n\n    >ion-icon {\n        margin: auto 1px auto auto;\n    }\n\n    >span {\n        margin: auto;\n    }\n}\n\n.background {\n    padding-top: 5px;\n}\n\n#textArea {\n    height: 20vh;\n}\n\n.post-user-avatar {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    border: 1px solid;\n    border-color: rgba(0, 0, 0, 0.06);\n}\n\n.user-comment-picture {\n    height: 38px;\n    width: 38px;\n    border-radius: 50%;\n}\n\n.user-name {\n    font-weight: 600;\n}\n\n.date {\n    font-size: 0.8em;\n    font-weight: 300;\n}\n\n.post-description {\n    margin: 6px 16px 15px;\n    // font-family: var(--font); font-weight: 400;;\n    font-family: var(--font);\n}\n\n.img-post {\n    width: 100%;\n    max-height: 200px;\n    object-fit: cover;\n}\n\n// .divider {\n// margin-top: 6px;\n// margin-bottom: 6px;\n// width: 100%;\n// height: 1px;\n// background: rgba(0, 0, 0, 0.04);\n// }\n\n.post-n-comment-div {\n    margin-left: 17px;\n    margin-top: 5px;\n    margin-bottom: 10px;\n}\n\n.delete-btn {\n    float: right;\n    padding-right: 10px;\n}\n\n.align-texts-like {\n    width: 100%;\n    display: inline-flex;\n    align-items: center;\n}\n\n\n.icon-like {\n    font-size: 1.4em;\n}\n\n.icon-comment {\n    margin-right: 3px;\n    font-size: 1.4em;\n}\n\n\n@media only screen and (min-width: 320px) {\n    .normal-text {\n        font-size: 0.96em;\n    }\n}\n\n.total-likes {\n    margin-left: 8px;\n}\n\n.input-comment {\n    resize: none;\n}\n\n.pos-btn-send {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.custom-col-size {\n    display: flex;\n    align-items: center;\n}\n\n.btn-send-msg {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    float: left;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.icon-send {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.view-more {\n    text-align: center;\n}\n\n.icon-fixed {\n    float: right;\n}\n\n#icon_fixed {\n    width: 17px;\n    height: 17px;\n}\n\n.icon-trash {\n    float: right;\n}\n\n.color-trash {\n    color: #c91f1f;\n}\n\n.st0 {\n    fill: #808080;\n}\n\n.btn-attach-picture {\n    font-size: 22px; // color: #000000;\n}\n\n.display-flex-align {\n    display: flex;\n    align-items: center;\n}\n\n.float-right {\n    float: right;\n}\n\n.float-left {\n    float: left;\n}\n\n.separator-vertical {\n    width: 1px;\n    // height: 55%;\n    background: var(--text-color-2nd-login-desktop);\n    margin-right: 6px;\n    opacity: 0.09;\n}\n\n#myImg {\n    width: 100%;\n    height: 100%;\n    border-radius: 6px;\n    object-fit: cover;\n}\n\n.description-input {\n    padding-top: 10px;\n    // padding-left: 100px; //\n    height: 85vh;\n    resize: none;\n    background: #ffffff;\n    border-bottom: 1px solid #ECEAF3;\n    --placehoder-color: #9D93C2;\n    font-style: var(--font); font-weight: 400;;\n}\n\n.text-input-ios {\n    margin: 0 auto;\n}\n\n.text-input-md {\n    margin: 0 auto;\n}\n\n.mg-card {\n    height: 90.5vh;\n}\n\n.btn-default {\n    padding: 8px;\n    font-size: 1em;\n    border-radius: 15px;\n    min-width: 100%;\n}\n\nion-avatar {\n    width: 46px;\n    height: 46px;\n    border: 2px solid transparent;\n    padding: 1px;\n    cursor: pointer;\n\n    img {\n        width: 44px;\n    }\n}\n\n.profile-picture {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n    object-position: center;\n    margin: 0 auto;\n    background: var(--bg-color);\n    padding: 10px;\n\n    .cus-picture {\n        width: 16px;\n        height: 16px;\n        margin: auto;\n        border-radius: 0;\n        opacity: 0.6;\n    }\n}\n\n.name-post {\n    // margin-left: 8px;\n    // margin-bottom: 8px;\n    font-family: var(--font); font-weight: 600;;\n    ;\n    cursor: pointer;\n}\n\n.post-date {\n    font-family: var(--font); font-weight: 300;;\n    opacity: 0.5;\n}\n\n.post-card-content {\n    padding: 0;\n\n    .post-img {\n        // width: 110%;\n        max-height: 60%;\n        // border-radius: 8px !important; //\n        //\n        display: block;\n    }\n}\n\n.align-footer-post {\n\n    // width: 100%;\n    // height: 100%;\n    // display: inline-flex;\n    // align-items: center;\n    ion-col {\n        display: flex;\n\n        .like-container {\n            display: flex;\n            // width: 20%;\n            padding-left: 9px;\n        }\n\n        .align-texts-comment {\n            // width: 20%;\n            display: inline-flex;\n            margin-left: 8px;\n            // align-items: center;\n            // justify-content: flex-end;\n        }\n\n        .nbr-likes-cmts {\n            font-family: var(--font); font-weight: 300;;\n            font-size: 14px;\n            margin: auto 0 auto 5px;\n        }\n\n        ion-icon {\n            width: 20px;\n            height: 20px;\n            cursor: pointer;\n        }\n    }\n}\n\n.social-sharing {\n    float: right;\n    font-size: 1.2em;\n}\n\n.header-post-item {\n    border: none !important;\n    padding: 0 !important;\n}\n\n.align-button-options {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.more-options-btn {\n    font-size: 1.4em;\n}\n\n.bottom-form {\n    margin: auto;\n    width: 98vw;\n    height: 60vh;\n    border: 3px solid rgb(212, 210, 210);\n    background-color: rgb(232, 232, 232);\n    padding: 10px;\n\n    .btn-icon{\n        display: flex;\n        align-items: flex-end;\n        margin-left:auto;\n        margin-right: auto;\n        width: 35%;\n        height: auto;\n    }\n    \n    >a {\n        display: flex;\n        align-items: flex-end;\n        margin-left:auto;\n        margin-right: auto;\n        width: 50%;\n        height: 50%;\n    }\n}\n\n.bottom-form2 {\n    margin: auto;\n    width: 55%;\n    height: auto;\n    max-height: 40%;\n    border: 3px solid rgb(212, 210, 210);\n    background-color: rgb(232, 232, 232);\n    padding: 10px;\n\n    ion-icon{\n        display: flex;\n        align-items: flex-end;\n        margin-left:auto;\n        margin-right: auto;\n        width: 50%;\n        height: auto;\n        max-height: 40%;\n    }\n    \n    >a {\n        display: flex;\n        align-items: flex-end;\n        margin-left:auto;\n        margin-right: auto;\n        width: 50%;\n        height: 50%;\n        max-height: 40%;\n    }\n}\n\nion-spinner{\n    margin: auto;\n    width: 5vw;\n    height: 2vh;\n    padding: 10px;\n\n}\nion-card {\n    max-width: 600px;\n    margin: 15px auto !important;\n    \n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 2px 9px 0 rgba(0, 0, 0, 0.1);\n}\n\n.btn-more {\n    --background: transparent;\n    color: black;\n    --box-shadow: none;\n    --background-hover: rgb(0 0 0 / 0.03);\n    --background-focused: rgb(0 0 0 / 0.03);\n\n    ion-icon {\n        transform: rotate(90deg);\n        width: 1.3rem;\n        height: 1.3rem;\n    }\n}\n.container{\n    position: relative;\n    >.wait-content{\n        position: absolute;\n        top: 15px;\n        left: 0;\n        width: 100%;\n        text-align: center;\n        font-family: var(--font); font-weight: 600;;\n        font-size: 1.3rem;\n    }\n    ion-icon{\n        height: 300px;\n        width: 100%;\n    }\n    .text-empty-content {\n        height: 70px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        margin: auto;\n        text-align: center;\n        font-family: var(--font);\n        .title{ \n            font-weight: 600;\n            font-size: 17px;\n            margin-bottom: 10px;\n        }\n    }\n}\n@media screen and (min-width: 768px) {\n    .container{\n        ion-icon{\n            height: 440px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
